import {
  OpensearchPaginationCursorSchema,
  SortDirection,
} from "@redotech/redo-model/tables/table";
import {
  AdvancedFilterDataSchema,
  FilterGroupSchema,
  VALID_PAGE_SIZES,
} from "@redotech/redo-model/views/views";
import { WorkOrderTableRowSchema } from "@redotech/redo-model/work-order/work-order-table-row";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getWorkOrders = {
  name: "getWorkOrders" as const,
  input: z.object({
    pageNumber: z.number(),
    pageSize: z
      .number()
      .refine((value) => VALID_PAGE_SIZES.includes(value as any), {
        message: `pageSize must be one of: ${VALID_PAGE_SIZES.join(", ")}`,
      }),
    search: z.string().nullish(),
    sort: z
      .object({ key: z.string(), direction: createEnum(SortDirection) })
      .nullish(),
    filterGroup: FilterGroupSchema.nullish(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).default([]),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
  output: z.object({
    workOrders: z.array(WorkOrderTableRowSchema),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
};
